import React, { useEffect, useState } from "react";
import ParagraphTag from "../../reusebale/Paragraph";
import { useSelector } from "react-redux";
import BaseUrl from "../../../constants/BaseUrl";
import moment from "moment";

const FlexWalletTile = () => {
  const { loginSuccess } = useSelector((state) => state.auth);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    fetch(`${BaseUrl}api/accountMapping/flexWalletBalance`, {
      method: "GET",
      headers: myHeaders,
    })
      .then((r) => r.json())
      .then((result) => {
        if (result.status === "success") setData(result.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [loginSuccess?.token]);

  return (
    <div className="bg-white rounded-2xl py-5 px-5 mt-6 shadow-md shadow-gray-200">
      <ParagraphTag
        content="Flex Account Balance"
        classes="text-darkColor font-popinsSemiBold text-base mb-3"
      />
      {loading ? (
        <div className="flex gap-6">
          {[0, 1].map((i) => (
            <div key={i}>
              <div className="h-3 bg-gray-200 rounded animate-pulse w-16 mb-1.5" />
              <div className="h-5 bg-gray-200 rounded animate-pulse w-24" />
            </div>
          ))}
        </div>
      ) : data ? (
        <div className="rounded-xl border border-gray-100 overflow-hidden">
          <div className="px-4 py-2 bg-gray-50 border-b border-gray-100">
            <p className="text-themeColor font-popinsSemiBold text-sm">
              Available Balance
            </p>
          </div>
          <div className="grid grid-cols-2 divide-x divide-gray-100">
            <div className="px-4 py-3">
              <p className="text-darkColor/50 font-popinsRegular text-xs mb-1">
                Balance
              </p>
              <p className="text-darkColor font-popinsSemiBold text-lg">
                $
                {Number(data.availableBalance || 0).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </p>
            </div>
            <div className="px-4 py-3">
              <p className="text-darkColor/50 font-popinsRegular text-xs mb-1">
                As Of
              </p>
              <p className="text-darkColor font-popinsSemiBold text-lg">
                {data.asOn ? moment(data.asOn).format("MM/DD/YY") : "—"}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-darkColor/40 font-popinsRegular text-sm">
          Balance unavailable
        </p>
      )}
    </div>
  );
};

export default FlexWalletTile;
